// extracted by css-extract-rspack-plugin
module.exports =  {"grid":"Grid__grid--p9N_S","col2":"Grid__col2--WFh7D","colGap":"Grid__colGap--1h2vW"};